import api from "@core/api/api";

/**
 * Admin Logs Service
 * Handles system logs and audit trail API calls
 */

const LOGS_BASE_URL = "/admin/logs";

export const adminLogsService = {
  /**
   * Get system logs
   * @param {Object} params - Query parameters
   * @returns {Promise} Logs data
   */
  async getLogs(params) {
    const response = await api.get(LOGS_BASE_URL, { params });
    return response.data;
  },

  /**
   * Export logs to file
   * @param {Object} params - Export parameters
   * @returns {Promise} Download response
   */
  async exportLogs(params) {
    const response = await api.get(`${LOGS_BASE_URL}/export`, {
      params,
      responseType: "blob",
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `system-logs-${new Date().toISOString()}.csv`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();

    return response.data;
  },

  /**
   * Get audit trail
   * @param {Object} params - Query parameters
   * @returns {Promise} Audit trail data
   */
  async getAuditTrail(params) {
    const response = await api.get(`${LOGS_BASE_URL}/audit`, { params });
    return response.data;
  },

  /**
   * Get security logs
   * @returns {Promise} Security logs
   */
  async getSecurityLogs(params) {
    const response = await api.get(`${LOGS_BASE_URL}/security`, { params });
    return response.data;
  },

  /**
   * Get log statistics
   * @returns {Promise} Log statistics
   */
  async getLogStats() {
    const response = await api.get(`${LOGS_BASE_URL}/stats`);
    return response.data;
  },
};
